<div class="max-width-p">
  <app-notification-banner></app-notification-banner>
  <benefit-header-summary
    [headerText]="'DETAILS.HEADER_TITLE1' | translate"
    [smallText]="'DETAILS.HEADER_TITLE2' | translate"
    [showBudgetCard]="false"
  >
  </benefit-header-summary>


  <div class="row">

    <!--Details section-->
    <div class="col-lg-8 col-12">
      <div class="card px-3 py-1">

        <!--Id + time stamp-->
        <div class="d-flex justify-content-between">
          <div class="bold text-dark" *ngIf="historyType === BenefitHistoryType.Order">
            {{ 'DETAILS.BENEFIT.BENEFIT_NUMBER' | translate }}{{ itemId }}
          </div>
          <div>{{ orderDetails?.date | localizedDate }}</div>
        </div>

        <hr/>

        <!--Image + details-->
        <div class="mb-1">
          <ng-container *ngIf="!orderDetails.isDeleted; else deletedTemplate">
            <a
              [routerLink]="['/' + subdomain + '/flexible-benefits-info/' + orderDetails.providerId + '/' + orderDetails.benefitId]"
              role="link" style="color:inherit;">
              <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            </a>
          </ng-container>

          <ng-template #deletedTemplate>
            <div ngbTooltip="{{ 'HISTORY.BENEFIT.NOT_AVAILABLE' | translate }}">
              <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            </div>
          </ng-template>

          <ng-template #contentTemplate>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
              <div class="mr-md-1 w-100 mw-25 mw-md-100">
                <img [src]="orderDetails?.pictureUrl"
                     alt="" role="presentation"
                     class="img-fluid rounded w-100"
                     style="height: auto;"
                />
              </div>
              <div class="d-flex flex-column w-100">
                <div class="mb-1">
                  <div *ngIf="!isInsuranceBenefit()" class="bold text-dark">{{ orderDetails?.name }}</div>
                  <div *ngIf="isInsuranceBenefit()" class="bold text-dark">{{ 'BENEFIT_TYPE_LABEL.INSURANCE' | translate }}</div>
                  <div>
                    {{ 'FLEXIBLE_FIXED_BENEFITS.TEXT.OFFERED_BY' | translate }}
                    <span class="semi-bold fs-12">{{ orderDetails?.providerName }}</span>
                  </div>
                </div>
                <ng-container *ngIf="this.benefitIsSubscription; else oneTime">
                  <div *ngIf="this.activationDate">
                    <span class="bold">{{ 'SUBSCRIPTION_PAYMENT.ACTIVATION_DATE' | translate }}:</span>
                    {{ this.activationDate }}
                  </div>
                  <div *ngIf="this.nextPayment">
                    <span class="bold">{{ 'DETAILS.NEXT_PAYMENT_DATE' | translate }}:</span>
                    <span>
                      {{ this.nextPayment | localizedDate: 'd MMMM y' }}
                    </span>
                  </div>
                  <div>
                    <span class="bold">{{ 'SUBSCRIPTION_PAYMENT.PERIOD' | translate }}:</span>
                    {{ this.orderDetails.subscriptionNumberOfMonths }} {{ 'SUBSCRIPTION_PAYMENT.MONTHS' | translate }}
                  </div>
                  <div>
                    <span class="bold">{{ 'FLEXIBLE_FIXED_BENEFITS.FILTER.LOCATION' | translate }}:</span>
                    <ng-container *ngFor="let loc of orderDetails.locations; let i = index">
                      {{ CountyLabel[loc] | translate }}
                      <span *ngIf="i < orderDetails.locations.length - 1">, </span>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-template #oneTime>
                  <div *ngIf="historyType === BenefitHistoryType.Order">
                    <span class="bold">{{ 'DETAILS.BENEFIT.QUANTITY' | translate }}:</span>
                    {{ orderDetails.noOfUnits }}
                  </div>
                  <div
                    *ngIf="historyType === BenefitHistoryType.AutoOrder && orderDetails.hasAutoOrderDynamicQuantity === false">
                    <span class="bold">{{ 'DETAILS.BENEFIT.QUANTITY' | translate }}:</span>
                    {{ orderDetails.noOfUnits }} / {{ 'HISTORY.AUTO_ORDER.QUANTITY_PER_MONTH' | translate }}
                  </div>
                  <div
                    *ngIf="historyType === BenefitHistoryType.AutoOrder && orderDetails.hasAutoOrderDynamicQuantity === true">
                    <span class="bold">{{ 'DETAILS.BENEFIT.QUANTITY' | translate }}:</span>
                    {{ 'HISTORY.AUTO_ORDER.QUANTITY_DYNAMIC' | translate }}
                  </div>
                </ng-template>
                <div>
                  <span class="bold">{{ 'BENEFIT_SUMMARY.BENEFITS.SHIPPING_TYPE' | translate }}:</span>
                  {{ orderDetails.shippingTypeLabel | translate }}
                </div>
                <div class="badge badge-pill badge-warning" *ngIf="orderDetails.isPlacedByAdmin">
                  {{ 'HISTORY.BENEFIT.PLACED_BY_ADMIN' | translate }}
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div>
          <p
            [innerHTML]="isDescriptionExpanded ? orderDetails?.benefitDescription : firstSentence() | sanitizeHtml"></p>
          <a *ngIf="showDescriptionToggle" class="a-primary" (click)="isDescriptionExpanded = !isDescriptionExpanded">
            {{
              (
                isDescriptionExpanded ? 'DETAILS.BENEFIT.DESCRIPTION_READ_LESS' : 'DETAILS.BENEFIT.DESCRIPTION_READ_MORE'
              ) | translate
            }}
          </a>
        </div>

        <!-- Beneficiaries -->
        <div *ngIf="orderDetails.beneficiary">
          <hr/>

          <div class="bold text-dark mb-1">
            {{ 'DETAILS.BENEFIT.BENEFICIARY_TITLE' | translate }}<span class="feather icon-users"
                                                                       style="margin-left: 5px"></span>
          </div>
          <div>
            <div style="margin-bottom: 5px">
              <span class="bold">{{ 'DETAILS.BENEFIT.BENEFICIARY_FULLNAME' | translate }}:</span>
              {{ orderDetails?.beneficiary.fullName }}
            </div>
            <div style="margin-bottom: 5px">
              <span class="bold">{{ 'DETAILS.BENEFIT.BENEFICIARY_CNP' | translate }}:</span>
              {{ maskCnp(orderDetails?.beneficiary.cnp) }}
            </div>
            <div style="margin-bottom: 5px">
              <span class="bold">{{ 'DETAILS.BENEFIT.BENEFICIARY_CITY' | translate }}:</span>
              {{ orderDetails?.beneficiary.city }}
            </div>
            <div style="margin-bottom: 5px">
              <span class="bold">{{ 'DETAILS.BENEFIT.BENEFICIARY_EMAIL' | translate }}:</span>
              {{ maskEmail(orderDetails?.beneficiary.email) }}
            </div>
            <div>
              <span class="bold">{{ 'DETAILS.BENEFIT.BENEFICIARY_PHONENUMBER' | translate }}:</span>
              {{ maskPhone(orderDetails?.beneficiary.phoneNumber) }}
            </div>
          </div>
        </div>

        <hr/>

        <!-- Insurance policies section -->
        <app-insurance-details
          *ngIf="isInsuranceBenefit()"
          [initialDetails]="insuranceDetails"
          [orderId]="itemId"
          [userId]="userId">
        </app-insurance-details>

        <!--Cost summary-->
        <div *ngIf="!isInsuranceBenefit()">
          <div class="bold text-dark mb-1">
            {{ 'DETAILS.BENEFIT.COSTS_SUMMARY' | translate }}
          </div>

          <!--Benefit Value section-->
          <div class="d-flex justify-content-between">
            <span>
              {{ (orderDetails?.paidFromSalary ? 'DETAILS.BENEFIT.VALUE_FROM_SALARY' : 'DETAILS.BENEFIT.VALUE') | translate }}
            </span>
            <div class="semi-bold dark-green text-right">
              {{
                orderDetails?.amountWithVAT
                  | number: '1.2-2'
              }} {{ 'DETAILS.UNIT1' | translate }}
            </div>
          </div>

          <!--Benefit taxes section-->
          <div class="d-flex justify-content-between mt-1"
               *ngIf="pricingPlan === PricingPlan.FLEX && historyType !== BenefitHistoryType.AutoOrder">
            <div class="d-flex flex-column"
                 ngbTooltip="{{ this.benefitPrice === 0 ? ('FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_TAXES_AND_FEES_TOOLTIP' | translate) : (taxAndFeesTooltipText | translate) }}" openDelay="400" placement="auto">
              <app-tax-category-display [category]="this.benefitPrice === 0 ? 0 : this.orderDetails.benefitTaxCategory"></app-tax-category-display>
              <div class="d-flex align-items-center">
                <span style="margin-right: 5px">
                  {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES' | translate }}
                </span>
                <i data-feather="info"></i>
              </div>
            </div>
            <div class="semi-bold dark-green text-right">
              <div>
                {{ taxesAndCamAmount | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
              </div>
              <app-benefit-details-tax-source [benefitDetails]="orderDetails"
                                              [companyTaxDistribution]="companyTaxDistribution"></app-benefit-details-tax-source>
            </div>
          </div>
        </div>

        <div *ngIf="historyType === BenefitHistoryType.Order && !isInsuranceBenefit()">
          <hr/>

          <div class="d-flex justify-content-between bold text-dark mb-1">
            <div>
              {{ 'DETAILS.BENEFIT.PAYMENT' | translate }}
            </div>
            <div class="semi-bold dark-green text-right">
              {{
                getOrderAmountToPay()
                  | number: '1.2-2'
              }} {{ 'DETAILS.UNIT1' | translate }}
            </div>
          </div>
        </div>

        <!--Payments history section-->
        <app-benefit-details-payment-history *ngIf="!isInsuranceBenefit()"
                                             [orderDetails]="orderDetails"
                                             [benefitPrice]="benefitPrice">
        </app-benefit-details-payment-history>

        <app-benefit-details-card-payment-history *ngIf="!isInsuranceBenefit()"
                                                   [orderDetails]="orderDetails">
        </app-benefit-details-card-payment-history>

        <!-- Subscription payments section-->
        <div *ngIf="this.benefitIsSubscription && this.subscriptionPayments">
          <hr/>
          <div class="d-flex justify-content-between">
            <div class="semi-bold dark-green">
              {{ 'SUBSCRIPTION_PAYMENT.PAYMENT_STATEMENT' | translate }}
            </div>
            <a class="a-primary" (click)="this.togglePayments()">
              <ng-container *ngIf=!this.paymentsExpanded>
                {{ 'SUBSCRIPTION_PAYMENT.EXPAND_PAYMENTS' | translate }} <span
                class="feather icon-chevron-down"></span>
              </ng-container>
              <ng-container *ngIf=this.paymentsExpanded>
                {{ 'SUBSCRIPTION_PAYMENT.COLLAPSE_PAYMENTS' | translate }} <i
                class="feather icon-chevron-up"></i>
              </ng-container>
            </a>
          </div>

          <div *ngIf="this.paymentsExpanded">
            <app-subscription-payment-table
              [benefitType]="orderDetails.benefitType"
              [benefitTaxCategory]="orderDetails.benefitTaxCategory"
              [payments]="this.subscriptionPayments"
              [taxDistributionSource]="this.companyTaxDistribution"
              [monthlyBudget]="this.userMonthlyBudget">
            </app-subscription-payment-table>
          </div>
        </div>

        <!-- Auto orders payments section -->
        <div *ngIf="this.benefitIsAutoOrder && this.autoOrderPayments">
          <hr/>
          <div class="d-flex justify-content-between">
            <div class="semi-bold dark-green">
              {{ 'SUBSCRIPTION_PAYMENT.PAYMENT_STATEMENT_AUTO_ORDER' | translate }}
            </div>
            <a class="a-primary" (click)="this.togglePayments()">
              <ng-container *ngIf=!this.paymentsExpanded>
                {{ 'SUBSCRIPTION_PAYMENT.EXPAND_PAYMENTS' | translate }} <span
                class="feather icon-chevron-down"></span>
              </ng-container>
              <ng-container *ngIf=this.paymentsExpanded>
                {{ 'SUBSCRIPTION_PAYMENT.COLLAPSE_PAYMENTS' | translate }} <i
                class="feather icon-chevron-up"></i>
              </ng-container>
            </a>
          </div>

          <div *ngIf="this.paymentsExpanded">
            <app-auto-order-payments-table
              [benefitType]="orderDetails.benefitType"
              [benefitTaxCategory]="orderDetails.benefitTaxCategory"
              [autoOrderPayments]="this.autoOrderPayments"
              [taxDistributionSource]="this.companyTaxDistribution">
            </app-auto-order-payments-table>
          </div>
        </div>

        <!--Benefit documents section -->
        <ng-container
          *ngIf="
                  orderDetails &&
                  documents &&
                  documents.length > 0
                "
        >
          <div class="d-flex mt-1">
            <div class="documents-container">
              <div class="bold text-dark">
                {{ 'DETAILS.REQUIRED_DOCUMENTS' | translate }}
              </div>
              <div class="border-container">
                <a
                  *ngFor="
                          let historyItemBenefitDocument of this.documents
                        "
                  href="javascript:void(0)"
                  [href]="historyItemBenefitDocument.documentUrl"
                  target="_blank"
                  class="text-dark document-card"
                >
                  <span [ngClass]="'icon-file-text'" class="feather"></span>
                  <div class="text-card">{{ historyItemBenefitDocument.displayName }}</div>
                </a>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="orderDetails?.submittedRequiredDocuments?.length > 0">
          <hr/>
          <div class="d-flex mt-1">
            <div class="documents-container">
              <div class="bold text-dark">
                {{ 'DETAILS.SUBMITTED_REQUIRED_DOCUMENTS' | translate }}
              </div>
              <div class="border-container">
                <a
                  *ngFor="let submittedDocument of orderDetails.submittedRequiredDocuments"
                  [href]="submittedDocument.uploadedDocumentUrl"
                  target="_blank"
                  class="text-dark document-card"
                >
                  <span [ngClass]="'icon-file-text'" class="feather"></span>
                  <div class="text-card">{{ submittedDocument.uploadedDocumentName }}</div>
                </a>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="orderDetails?.submittedConsents?.length > 0">
          <hr/>
          <div class="d-flex mt-1">
            <div class="documents-container">
              <div class="bold text-dark">
                {{ 'DETAILS.SUBMITTED_CONSENTS' | translate }}
              </div>
              <div class="border-container">
                <div
                  *ngFor="let submittedConsent of orderDetails.submittedConsents"
                  class="submitted-consent-row text-dark"
                >
                  <span
                    class="feather"
                    [ngClass]="submittedConsent.checked ? 'icon-check-square' : 'icon-circle'"
                  ></span>
                  <div class="text-card">{{ submittedConsent.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="orderDetails?.submittedRequiredFields?.length > 0">
          <hr/>
          <div class="d-flex mt-1">
            <div class="submitted-fields-container w-100">
              <div class="bold text-dark mb-1">
                {{ 'DETAILS.SUBMITTED_REQUIRED_FIELDS' | translate }}
              </div>
              <div
                *ngFor="let submittedField of orderDetails.submittedRequiredFields"
                class="submitted-field-row"
              >
                <span
                  class="feather submitted-field-icon"
                  [ngClass]="submittedField.fieldType === RequiredFieldTypes.None ? 'icon-align-left' : 'icon-mail'"
                ></span>
                <div class="submitted-field-text">
                  <div class="submitted-field-label">{{ submittedField.fieldLabel }}</div>
                  <div class="submitted-field-value">{{ submittedField.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="this.orderDetails?.vouchers && this.orderDetails?.vouchers?.length > 0">
          <hr/>

          <div class="bold text-dark mb-1">
            {{ 'DETAILS.BENEFIT.VOUCHERS' | translate }}
          </div>

          <div *ngFor="let voucher of this.orderDetails?.vouchers; let i = index">
            <div class="d-flex align-items-center justify-content-between" *ngIf="voucher.code">
              <div class="">{{ 'DETAILS.BENEFIT.VOUCHER.CODE' | translate }}:</div>
              <div *ngIf="voucher.barcode; else codeOnly" class="d-flex flex-column align-items-center">
                <img src="{{voucher.barcode}}" alt="barcode" style="width: 300px;"/>
                <div class="d-flex align-items-center semi-bold dark-green text-right overflow-auto">
                  <span>{{ voucher.code }}</span>
                  <a class="d-flex semi-bold dark-green text-right" (click)="copyCode(voucher.code)">
                    <i [data-feather]="'clipboard'"></i>
                  </a>
                </div>
              </div>
              <ng-template #codeOnly>
                <div class="d-flex align-items-center semi-bold dark-green text-right overflow-auto">
                  <span>{{ voucher.code }}</span>
                  <a class="d-flex semi-bold dark-green text-right" (click)="copyCode(voucher.code)">
                    <i [data-feather]="'clipboard'"></i>
                  </a>
                </div>
              </ng-template>
            </div>
            <div class="d-flex justify-content-between" *ngIf="voucher.pin">
              <div>{{ 'DETAILS.BENEFIT.VOUCHER.PIN' | translate }}:</div>
              <div class="semi-bold dark-green text-right overflow-auto">{{ voucher.pin }}</div>
            </div>
            <div class="d-flex justify-content-between" *ngIf="voucher.url">
              <div>{{ 'DETAILS.BENEFIT.VOUCHER.URL' | translate }}:</div>
              <div class="semi-bold dark-green text-right overflow-auto">
                <a class="semi-bold dark-green" href="{{voucher.url}}">{{ voucher.url }}</a>
              </div>
            </div>
            <div class="d-flex justify-content-between" *ngIf="voucher.expires_at">
              <div>{{ 'DETAILS.BENEFIT.VOUCHER.EXPIRESAT' | translate }}:</div>
              <div
                class="semi-bold dark-green text-right overflow-auto">{{ getValidDate(voucher.expires_at) | localizedDate }}
              </div>
            </div>
            <div *ngIf="this.orderDetails?.vouchers?.length > i+1" class="mt-1"></div>
          </div>
        </ng-container>

      </div>
    </div>

    <!-- Status and price -->
    <div class="col-lg-4 col-12">
      <div class="card px-3 py-1">
        <div class="align-items-center d-flex justify-content-between"
             *ngIf="orderDetails">
          <app-benefit-history-status
            [benefitHistoryType]="historyType"
            [isAutoOrderEnabled]="orderDetails.isAutoOrderEnabled"
            [orderStatus]="orderDetails.orderStatus"
            [orderStatusLabel]="orderDetails.orderStatusLabel"
            [subscriptionStatus]="orderDetails.subscriptionStatus"
            [subscriptionStatusLabel]="orderDetails.subscriptionStatusLabel"
          ></app-benefit-history-status>
          <h4 *ngIf="historyType !== BenefitHistoryType.AutoOrder && !isInsuranceBenefit()" style="padding-left: 6px"
              class="semi-bold dark-green text-right mb-0">
            {{ totalOrderAmountWithTaxes | number: '1.2-2' }}
            {{ 'DETAILS.UNIT1' | translate }}
          </h4>
          <h4 *ngIf="historyType === BenefitHistoryType.AutoOrder && !isInsuranceBenefit()" style="padding-left: 6px"
              class="semi-bold dark-green text-right mb-0 text-nowrap">
            {{ totalOrderAmountWithTaxes | number: '1.2-2' }}
            {{ 'DETAILS.UNIT3' | translate }}
          </h4>
        </div>

        <div *ngIf="orderDetails.orderStatus != null && (orderDetails.orderStatus && (orderDetails.orderStatus === OrderStatus.Created || orderDetails.orderStatus === OrderStatus.PaymentPending || orderDetails.orderStatus === OrderStatus.PaymentRefused) &&
                      orderDetails.acquisitionType !== 2 && orderDetails.isOrderInCurrentMonth === true)">
          <hr/>

          <button class="btn btn-outline-danger-darker w-100"
                  [disabled]="isCancelRestrictedByOrderPeriod"
                  (click)="CancelOrderWithConfirmation()">
            {{ 'DETAILS.QUIT_BENEFIT' | translate }}
          </button>
          <span *ngIf="isCancelRestrictedByOrderPeriod" class="d-block mt-1 small text-muted">
            {{ 'DETAILS.CANCEL_RESTRICTED_INFO' | translate }}
          </span>
        </div>

        <div *ngIf="orderDetails.cardPaymentHistory &&
          !orderDetails?.cardPaymentHistory[
          orderDetails.cardPaymentHistory.length - 1
          ]?.isPaid
          && !orderDetails?.cardPaymentHistory[
          orderDetails.cardPaymentHistory.length - 1
          ]?.isPending
          ">
          <button class="btn btn-warning-darker mt-1 w-100"
                  (click)="directRetryPayment()"
                  [disabled]="disableFinalizeButton()"
                  *ngIf="
                        orderDetails.orderStatus &&
                        (!orderDetails.subscriptionStatus) &&
                        (orderDetails.orderStatus === OrderStatus.PaymentPending  ||
                          orderDetails.orderStatus === OrderStatus.PaymentRefused)
                      ">
            <span class="feather icon-corner-down-left mr-10"></span>
            {{ 'DETAILS.RETRY_PAYMENT' | translate }}
          </button>
          <div class="not-eligible-warning font-small-3 mt-2" *ngIf="disableFinalizeButton() === true">
            {{ 'PAYMENT_RETRY.NOT_ENOUGH_BUDGET' | translate }}
          </div>
        </div>
      </div>

      <!-- Private Pension Contribution Card -->
      <div class="card px-3 py-2 mt-2" *ngIf="benefitIsSubscription && pensionContribution !== null">
        <div class="d-flex align-items-center mb-2">
          <i class="feather icon-shield mr-2 text-primary" style="font-size: 1.5rem;"></i>
          <div class="flex-grow-1">
            <div class="text-muted small">{{ 'DETAILS.BENEFIT.PRIVATE_CONTRIBUTION' | translate }}</div>
            <h5 class="mb-0 semi-bold dark-green">{{ pensionContribution }} RON / {{ 'DETAILS.BENEFIT.MONTH' | translate }}</h5>
          </div>
        </div>
        <button
          class="btn btn-sm btn-outline-primary w-100"
          (click)="openPensionDialog()"
          [disabled]="isPensionDialogDisabled()"
        >
          <i class="feather icon-edit-2 mr-1"></i>
          {{ 'DETAILS.BENEFIT.MODIFY' | translate }}
        </button>
      </div>

      <app-auto-order *ngIf="benefitIsAutoOrder"
                      [userId]="userId"
                      [benefitId]="orderDetails.benefitId"
                      [benefitName]="orderDetails.name"
                      [beneficiaryId]="orderDetails.beneficiary?.id"
                      [billingAddressId]="orderDetails.billingAddressId"
                      [shippingAddressId]="orderDetails.shippingAddressId"
                      [historyType]="historyType"
                      [orderStatus]="orderDetails.orderStatus"
      ></app-auto-order>

      <form *ngIf="issueValues" [formGroup]="issueForm" class="card px-3 py-1" style="z-index: 0">
        <span class="bold text-dark">
          {{ 'DETAILS.BENEFIT_HELP' | translate }}
        </span>
        <hr/>
        <div class="form-group">
          <label class="fs-1rem" for="ticketReason">
            {{ 'DETAILS.PROBLEM' | translate }}
          </label>
          <ng-select [searchable]="false"
                     id="ticketReason"
                     labelForId="ticketReason"
                     [placeholder]="'DETAILS.REASON' | translate"
                     formControlName="issue"
                     appNgSelectAriaControl>
            <ng-option [value]="issueValues.LoginPassword">
              {{ 'DETAILS.REASON_LOGIN_PASSWORD' | translate }}
            </ng-option>
            <ng-option [value]="issueValues.FlexibleBenefits">
              {{ 'DETAILS.REASON_FLEXIBLE_BENEFITS' | translate }}
            </ng-option>
            <ng-option [value]="issueValues.Taxes">
              {{ 'DETAILS.REASON_TAXES' | translate }}
            </ng-option>
            <ng-option [value]="issueValues.PlacedOrders">
              {{ 'DETAILS.REASON_PLACED_ORDERS' | translate }}
            </ng-option>
            <ng-option [value]="issueValues.Others">
              {{ 'DETAILS.REASON_OTHERS' | translate }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group mt-2 w-100">
          <label class="fs-1rem" for="problemSummary">
            {{ 'DETAILS.DESCRIBE_PROBLEM' | translate }}
          </label>
          <textarea
            class="form-control"
            formControlName="message"
            rows="6"
            placeholder="{{ 'DETAILS.PROBLEM_DESCRIPTION' | translate }}"
            id="problemSummary">
        </textarea>
        </div>

        <button
          type="submit"
          (click)="addSupportMessage()"
          class="btn btn-primary mt-2"
        >
          {{ 'DETAILS.SENT' | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
